import React from "react";

export default class SpinnerGrow extends React.Component {
  render = () => (
    <div className="spinner-grow" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
